// @ts-nocheck
import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'legalboxplus-flag-status',
    templateUrl: './flag-status.component.html',
    imports: [NgClass]
})
export class FlagStatusComponent {
	public value;
	@Input('value') set localValue(inputValue) {
		this.value = inputValue;
	}
	@Input() type = 'default';

	public status = {
		default: {
			['valid']: {
				color: 'bg-success',
				label: 'Validado',
			},
			['init']: {
				color: 'bg-primary',
				label: 'Audiência Criada',
			},
			['await_integration']: {
				color: 'bg-warning',
				label: 'Enviando para o LB',
			},
			['await_double_check']: {
				color: 'bg-warning',
				label: 'Double Check',
			},
			['canceled']: {
				color: 'bg-error',
				label: 'Cancelada',
			},
			['await_designate']: {
				color: 'bg-warning',
				label: 'DC Validado',
			},
			['await_responsible']: {
				color: 'bg-warning',
				label: 'Designada',
			},
			['await_judgement']: {
				color: 'bg-success',
				label: 'Em Andamento',
			},
			['PC']: {
				color: 'bg-gray-700',
				label: 'Pendente de Confirmação',
			},
			['PV']: {
				color: 'bg-gray-700',
				label: 'Pendente de Verificação',
			},
			['PD']: {
				color: 'bg-gray-700',
				label: 'Pendente',
			},
			['VI']: {
				color: 'bg-gray-700',
				label: 'Vinculado',
			},
			['TD']: {
				color: 'bg-gray-700',
				label: 'Tarefa Divergente',
			},
			['RL']: {
				color: 'bg-gray-700',
				label: 'Retornado para Log 2',
			},
			['EA']: {
				color: 'bg-gray-700',
				label: 'Em Andamento',
			},
			['OK']: {
				color: 'bg-gray-700',
				label: 'Concluído',
			},
			['CC']: {
				color: 'bg-gray-700',
				label: 'Cancelado',
			},
			['RD']: {
				color: 'bg-gray-700',
				label: 'Retorno de Divergência',
			},
			['started']: {
				color: 'bg-warning',
				label: 'Diligencia Criada',
			},
			['await_emergency_approve']: {
				color: 'bg-warning',
				label: 'Aprovação Emergencial',
			},
			['await_return']: {
				color: 'bg-warning',
				label: 'Retorno da Aprovação',
			},
			['await_integration_return']: {
				color: 'bg-warning',
				label: 'Retorno da Integração',
			},
			['await_ata']: {
				color: 'bg-warning',
				label: 'Aguardando ATA',
			},
			['await_record_reading']: {
				color: 'bg-warning',
				label: 'Leitura de ATA',
			},
			['await_divergent_record']: {
				color: 'bg-warning',
				label: 'ATA Divergente',
			},
			['finished']: {
				color: 'bg-success',
				label: 'Finalizada',
			},
		},
		preRegister: {
			['open']: {
				color: 'bg-gray-700',
				label: 'Em aberto',
				type: 'pre-register',
			},
			['canceled']: {
				color: 'bg-error',
				label: 'Cancelado',
			},
			['done']: {
				color: 'bg-success',
				label: 'Concluído',
			},
			['finished']: {
				color: 'bg-success',
				label: 'Concluído',
			},
		},
	};
}
